import { render, staticRenderFns } from "./PatientAgainIn.vue?vue&type=template&id=255d6a87&scoped=true"
import script from "./PatientAgainIn.vue?vue&type=script&lang=js"
export * from "./PatientAgainIn.vue?vue&type=script&lang=js"
import style0 from "./PatientAgainIn.vue?vue&type=style&index=0&id=255d6a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d6a87",
  null
  
)

export default component.exports